export const TRACKING_COOKIE_NAME = 'axeptio_authorized_vendors';
export const TRACKING_COOKIE_AMPLITUDE = 'amplitude';
